"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _index = require("@/utils/index");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _LangSelect = _interopRequireDefault(require("@/components/LangSelect"));
var _ChangeRole = _interopRequireDefault(require("@/components/Common/ChangeRole"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import SystemSelect from '@/components/SystemSelect'
// import Search from '@/components/HeaderSearch'
var _default = exports.default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    LangSelect: _LangSelect.default,
    ChangeRole: _ChangeRole.default
    // SystemSelect
    // Search
  },
  data: function data() {
    return {
      loadingComponent: null,
      isLoading: false,
      isShowModelModifypass: false,
      isShowModelChangeRole: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'avatar', 'name', 'device', 'functions'])),
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  methods: {
    getRoleName: _index.getRoleName,
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    /**
     * 询问是否修改密码
     */
    modifyPass: function modifyPass() {
      var _this = this;
      this.$confirm(this.$t('common.confirm13'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'info'
      }).then(function () {
        setTimeout(function () {
          // 延时处理避免body的el-popup-parent--hidden类无法刷新
          _this.isShowModelModifypass = true;
        }, 200);
      }).catch(function () {});
    },
    /**
     * 切换角色
     */
    changeRole: function changeRole() {
      this.isShowModelChangeRole = true;
    },
    /**
     * 登出
     */
    logout: function logout() {
      var _this2 = this;
      this.isLoading = true;
      this.$api.login.logout().then(function (res) {
        _this2.isLoading = false;
        _this2.$store.dispatch('user/logout');
        _this2.$router.push("/login?redirect=".concat(_this2.$route.fullPath));
      }).catch(function () {
        _this2.isLoading = false;
      });
    }
  }
};